<template>
  <div>
    <b-modal
      id="authModal"
      centered
      :hide-footer="true"
      class="modal fade"
      content-class="custom-modal mt-5"
      body-class="p-0"
      :title="$t(`lang.navbar.${openedForm}`)"
    >
      <div
        id="sign-in-dialog"
        class="zoom-anim-dialog"
      >
        <div class="sign-in-wrapper pt-3 pb-3">
          <!--Show only on non-app and android app. Hide on ios and Ualabee app-->
          <div>
            <b-link
              href="#"
              class="social_bt facebook"
              @click="socialNetworkLogin('facebook')"
            >
              <span class="float-left"><i class="fab fa-facebook-f" /></span>
              {{ $t('lang.forms.sign_in_social') }} Facebook
            </b-link>

            <b-link
              href="#"
              class="social_bt google"
              @click="socialNetworkLogin('google')"
            >
              <span class="float-left"><i class="fab fa-google" /></span>
              {{ $t('lang.forms.sign_in_social') }} Google
            </b-link>

            <Errors :errors="errors" />

            <div class="divider m-2" />
          </div>

          <!--            FORM - CONTENT-->
          <Login
            v-if="openedForm==='login'"
            @authenticatedUser="authenticateUser"
          />

          <div v-if="openedForm==='login'">
            <div class="text-right mb-2">
              <button
                id="forgot"
                type="button"
                class="btn btn-link"
                @click="setShowAuthModal('forgotPassword')"
              >
                {{ $t('lang.forms.forgot_password') }}
              </button>
            </div>
          </div>

          <RegisterForm
            v-if="openedForm==='register'"
            @authenticatedUser="authenticateUser"
          />

          <ForgotPassword v-if="openedForm==='forgotPassword'" />

          <!--            CHANGE TO LOGIN/REGISTER -->
          <div class="text-center mb-2">
            <div v-if="openedForm==='login'">
              <label>{{ $t('lang.forms.dont_have_account') }}

                <b-link
                  href="#"
                  @click="setShowAuthModal('register')"
                > {{ $t('lang.titles.signup') }}<i class="m-0 icon-right-small" />

                </b-link>

              </label>
            </div>

            <div v-if="openedForm==='register'||openedForm==='forgotPassword'">
              <label>{{ $t('lang.forms.have_account') }}

                <b-link
                  href="#"
                  @click="setShowAuthModal('login')"
                > {{ $t('lang.titles.singin') }}<i class="m-0 icon-right-small" />

                </b-link>

              </label>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Login from './Login';
import RegisterForm from './RegisterForm';
import ForgotPassword from './ForgotPassword';
import Errors from '../Alerts/Errors';
import setAuthenticatedUserData from './Authentication';

export default {
  name: 'AuthenticationModal',
  components: {
    ForgotPassword, RegisterForm, Login, Errors,
  },

  data() {
    return {
      newUserData: {},
      errors: {},
      popupReference: null,
    };
  },

  computed: {
    openedForm() {
      const form = this.$store.state.general.authToShow;
      return form;
    },
  },

  methods: {

    setShowAuthModal(authToShow) {
      this.$store.dispatch('setAuthToShow', authToShow);
    },

    socialNetworkLogin(provider) {
      if (this.$store.state.main.app) {
        const currentURL = new URL(window.location.href);

        if (currentURL.searchParams.has('social-network-auth')) {
          currentURL.searchParams.delete('social-network-auth');
        }
        currentURL.searchParams.append('social-network-auth', provider);
        currentURL.searchParams.append('uuid', this.$store.state.main.uuid);

        // No se usa con router para que la app detecte cambio de url.
        window.location.replace(currentURL.href);
      } else { // If its not from app
        this.openPopUp(provider);
      }
    },

    openPopUp(provider) {
      window.removeEventListener('message', this.receiveMessage);

      this.openSignInWindow();
      this.popupReference.location = `${process.env.VUE_APP_URL}/auth/${provider}/redirect`;
      window.addEventListener('message', (event) => this.receiveMessage(event), false);
    },

    openSignInWindow() {
      const width = 500;
      const height = 600;
      const left = (window.screen.width / 2) - (width / 2);
      const top = (window.screen.height / 2) - (height / 2);
      const popUpFeatures = `toolbar=no, menubar=no, width=${width}, height=${height}, top=${top}, left=${left}`;

      if (this.popupReference === null || this.popupReference.closed) {
        // nueva ventana
        this.popupReference = window.open('', 'Sing In', popUpFeatures);
      } else {
        // ya esta abierta, la cierra y abre una nueva. (Hacer foco no funciona ne safari)
        this.popupReference.close();
        this.popupReference = window.open('', 'Sing In', popUpFeatures);
      }
    },

    receiveMessage(event) { // cuando cierra el processSocialAuth con la data de autenticación
      const { data } = event;

      if (event.origin !== process.env.VUE_APP_URL || data.source !== 'signInPopUp') {
        return;
      }

      if (data.source === 'signInPopUp') {
        window.removeEventListener('message', this.receiveMessage);

        this.authenticateUser(data, data.action);
      }
    },

    // data: user data, action: login/sign_up for analytics
    authenticateUser(data, action) {
      let redirectUrl = '';
      // when the url has "refer" we need to let it so when the page reloads open the referral modal
      if (this.$route.params.action && this.$route.params.action !== 'refer') {
        redirectUrl = process.env.VUE_APP_URL;
      } else {
        redirectUrl = new URL(window.location.href);
      }

      const authData = {
        token: data.token,
        email: data.user.email,
        id: data.user.id,
        doc_type: data.user.doc_type,
        full_name: data.user.full_name,
        action,
        redirect_url: redirectUrl,
        country: data.user.country,
      };
      setAuthenticatedUserData(authData, this.$store, this.$gtag, this.$currencyByCountry);
    },

  },
};
</script>

<style scoped>

</style>
